import {showMessage} from 'exsportia-components'

import {API} from '../../networking/http'
import {MutationMethod} from '../helpers/types'

type splitPaymentParticipant = {
  totalPrice?: number
  discount?: number
  equipmentDiscount?: number
  initialDiscount?: number
  isPaid?: boolean
  toPay?: boolean
}

export type CheckSplitBookingPaymentPartsRequest = {
  venueId: string
  uid: string // used to fetch the booking
  bookingId: string // used to update
  sum: number // used as total payment
  paymentMethodId: string | null // token payment method
  callAfterSuccessCheck?: () => void
  callAfterErrorCheck: () => void
  data: {
    venueId: string
    name?: string
    phone?: string
    email?: string
    userId?: string
    participants: splitPaymentParticipant[]
  }
}

export type CheckSplitBookingPaymentPartsParams = undefined
export type CheckSplitBookingPaymentPartsMutationParams = CheckSplitBookingPaymentPartsRequest
export type CheckSplitBookingPaymentPartsMutationReturnType = {
  canContinuePaymentProcess?: boolean
}
export type CheckSplitBookingPaymentPartsMutation = MutationMethod<
  CheckSplitBookingPaymentPartsParams,
  CheckSplitBookingPaymentPartsMutationParams,
  CheckSplitBookingPaymentPartsMutationReturnType
>

export const checkSplitBookingPaymentPartsEndpoint = 'bookings/split/:bookingId/checkPaymentParts'

export const checkSplitBookingPaymentPartsMutation: CheckSplitBookingPaymentPartsMutation = () => ({
  mutationFn: (bookingData) => {
    const {bookingId, callAfterSuccessCheck, callAfterErrorCheck, ...requestData} = bookingData
    const endpoint = checkSplitBookingPaymentPartsEndpoint.replace(':bookingId', bookingId)

    return API.post<CheckSplitBookingPaymentPartsMutationParams, CheckSplitBookingPaymentPartsMutationReturnType>(
      endpoint,
      requestData,
    )
      .then((res) => {
        if (callAfterSuccessCheck && res.data.canContinuePaymentProcess) {
          callAfterSuccessCheck()
        } else {
          callAfterErrorCheck()
        }
        return res.data
      })
      .catch((error) => {
        // eslint-disable-next-line
        showMessage(
          `Error checking payment parts: ${error?.response?.data?.message ?? 'Check Payment Parts Failed'}`,
          'error',
        )
        throw error
      })
  },
})
